import React from 'react'
import da from '../assets/da.jpg'

const DA = () => {
  return (
    <div className="min-h-screen bg-[#0A0F20] flex flex-col items-center justify-center p-6">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center">
            Data Analyst Roadmap for Beginners
          </h1>
          <div className="bg-gray-800 p-4 rounded-lg shadow-lg max-w-4xl w-full">
            <img
              src={da}
              alt="Java Roadmap "
              className="w-full h-auto rounded-md"
            />
          </div>
        </div>
  )
}

export default DA
